/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { validateRequired } from './validateRequired';

export function validateEmailRequired(value: string | number) {
  return validateRequired(value, 'error_Common_Validation_EmailIsRequired');
}
